import { Directive, HostListener, Optional } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[tooltipCloseOnLeave], .user-state-button[matTooltip]',
})
export class TooltipCloseOnLeaveDirective {
  constructor(@Optional() private tooltip: MatTooltip) {
    // console.log('TooltipCloseOnLeaveDirective initialized');
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    // console.log('TooltipCloseOnLeaveDirective mouseleave');
    this.tooltip?.hide();
  }
}
